<template >
     
    <div class="login-bg">
       
    <w-app id="app" class="justify-space-between basis-zero justify-center align-center login-bg">
      <w-transition-bounce>

       
        <w-alert
          class="my0 mb2 text-light"
          v-if="success"
          success
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{ success }}
        </w-alert>
        </w-transition-bounce>
        <w-transition-bounce>

        <w-alert
          class="my0 mb2 text-light"
          v-if="salah"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{salah}}
        </w-alert>
      </w-transition-bounce>

      <w-notification
        v-if="$page.props.flash.notify"
        success
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notify = ''"
        >
        {{$page.props.flash.notify}}
      </w-notification>

      <!-- <w-notification
        v-if="$page.props.flash.errors"
        error
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.errors = ''"
        >
        {{$page.props.flash.errors}}
      </w-notification> -->
      <header></header>
      
      <main class="grow align-self-center mt10">
        
        <w-card class="zloginbox-title">

          <div class="zloginbox-title-top">iHasil</div>
          <div class="zloginbox-title-bottom">Tukar Kata Laluan</div>

        </w-card>

        <w-card class="zloginbox">
        <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.errors"
          error
          transition="bounce"
          plain
          round
          timeout="2000"
          no-border
          dismiss
          >
            {{$page.props.flash.errors}}
        </w-alert>
        <template #buttons />

          <w-form
            @validate="submitPassword"
          >
           
            
            <div class="spacer"></div>
            <z-input 
              outline
              label="Katalaluan lama" 
              class="mt3"
              placeholder="Sila Masukkan Katalaluan" 
             :type="isPassword ? 'password' : 'text'"
             :inner-icon-right="isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
             @click:inner-icon-right="isPassword = !isPassword"  
              name="old_password"
              v-model="form.old_password"
              :validators="[validators.required]"
            />
             <w-tooltip
                            right
                            align-bottom
                            color="white"
                            bg-color="blue"
                        >
                            <template #activator="{ on }">
                                <span v-on="on">
            <div class="spacer"></div>
            <z-input 
              outline
              label="Katalaluan Baru" 
              class="mt3"
              placeholder="Sila Masukkan Katalaluan" 
              :type="isPassword1 ? 'password' : 'text'"
              :inner-icon-right="isPassword1 ? 'fal fa-eye-slash' : 'fal fa-eye'"
              @click:inner-icon-right="isPassword1 = !isPassword1" 
              name="password"
              v-model="form.password"
              :validators="[validators.required, validators.regex, validators.min8]"
            />
            </span>
                            </template>
                            Medan Ini Wajib mempunyai huruf besar, huruf kecil,
                            nombor, simbol dan minimum 8 aksara
                        </w-tooltip>
                        <w-tooltip
                            right
                            align-bottom
                            color="white"
                            bg-color="blue"
                        >
                            <template #activator="{ on }">
                                <span v-on="on">
            <div class="spacer"></div>
            <z-input 
              outline
              label="Ulang Katalaluan" 
              class="mt3"
              placeholder="Sila Masukkan Katalaluan" 
               :type="isPassword2 ? 'password' : 'text'"
              :inner-icon-right="isPassword2 ? 'fal fa-eye-slash' : 'fal fa-eye'"
              @click:inner-icon-right="isPassword2 = !isPassword2" 
              name="password_confirmation"
              v-model="form.password_confirmation"
              :validators="[validators.required, validators.regex, validators.min8]"
            />
             </span>
                            </template>
                            Medan Ini Wajib mempunyai huruf besar, huruf kecil,
                            nombor, simbol dan minimum 8 aksara
                        </w-tooltip>
            <template v-if="form.password != form.password_confirmation">
            <div style="color: red;">Kata Laluan tidak sepadan</div></template> 

              <div class="mt5 mb5"></div>


              <w-flex justify-center align-center class="mt5">

                    <!--
                    <w-button
                      class="my1 mr2"
                      bg-color="warning"
                      type="reset">
                      Reset
                    </w-button>
                    -->

                    <w-button
                      class="my2 btn-zloginbox grow"
                      type="submit"
                    >
                      <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> Hantar
                    </w-button>

              </w-flex>

          </w-form>
           <w-flex justify-center align-center>
                        <w-button
                            bg-color="grey-light5--bg"
                            class="my2 btn-zloginboxback grow"
                            type=""
                            @click="back()"
                        >
                            <w-icon class="mr2" xs>fal fa-arrow-left</w-icon>
                            Kembali
                        </w-button>
                    </w-flex>
        </w-card>

        <div class="zloginbox-title-footer">
              <b>#HAK CIPTA TERPELIHARA © 2022 KERAJAAN NEGERI KEDAH</b>
        </div>

        

      

      </main>

      <footer>
      </footer>
    </w-app>
  
  </div>
</template>

<style scoped>
.inner-icon-right {
  color: red;
}

</style>
<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  data() {
    return {
                   isPassword: true,
                   isPassword1: true,
            isPassword2: true,
      form: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      success : '',
      salah : '',
     
    }
  },
  methods: {
    back() {
            window.history.back();
        },

    submitPassword() {
    
      this.$inertia.post('changePassword',this.form)
    },
    notify(msg, success = true) {
    if(success)
    
      this.success = msg
    else
      this.salah = msg
  }
  }
}
</script>

<style>
#app {
  flex-direction: column;
}
.login-bg {
    /* background: url(/images/landpage.jpg) !important; */
    background-size: cover !important;
    background-repeat: no-repeat !important;
}
.zloginbox {
  width: 420px;
  background: inherit !important;
}
.zloginbox .w-card__content {
    background: #fff;
}
.zloginbox .w-toolbar {
    background-color: #0c213ab8;
    color: #fff;
}
.zloginbox .w-input__input-wrap {
    margin-top: 25px;
}
.zloginbox .w-input__label--inside {
    font-size: 15px;
    margin-top: -5px;
    margin-left: -5px;
}
.zloginbox .w-input__input-wrap--box {
    height: 33px;
}
.zloginbox .w-card__content {
    padding: 16px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}
.w-card.zloginbox-title {
    background: #0c213ab8;
    color: #fff;
    text-align: center;
    background: #3d272ab0;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-top: 1px solid #8c6c68;
    border-left: 1px solid #8c6c68;
    border-right: 1px solid #8c6c68;
    margin-top:150px;
}
.zloginbox-title-top{
    font-weight: bold;
    font-size: 15px;
    text-shadow: 1px 1px black;
}
.zloginbox-title-bottom {
    margin-bottom: 10px;
    margin-top: 5px;
}
.zloginbox-logo img {
    height: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.btn-zloginbox{
    color: #fff;
    background-color: #1761fd !important;
    border-color: #1761fd !important;
    font-size: 13px !important;
    padding: 15px;
}
.zloginbox-title-footer {
    text-align: center;
    font-size: 13px;
    color: #fff;
    margin-top: 10px;
    text-shadow: 1px 1px black;
}

</style>